import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { route } from '../../route/Index';
import { useAppDispatch } from '../../store/hook';
import { cleanResult } from '../../store/result/resultSlice';
import { cleanProject } from '../../store/project/projectSlice';
import { cleanAlert } from '../../store/alert/alertSlice';
import Span from '../../shared/component/Span';
import { cleanEngine } from '../../store/engine/engineSlice';
import { cleanMap } from '../../store/map/mapSlice';

interface IBackofficeProps {}

const Backoffice = (props: IBackofficeProps) => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(cleanResult());
        dispatch(cleanEngine());
        dispatch(cleanMap());
        dispatch(cleanProject());
        dispatch(cleanAlert());
        navigate(route.backoffice);
    };

    return (
        <Button variant='greenLight' startIcon={<EditIcon />} onClick={handleClick}>
            <Span text={t('backoffice')} />
        </Button>
    );
};

export default Backoffice;
